import { createAsyncThunk } from "@reduxjs/toolkit";
import * as URLS from "../../urls";
//axios
import axios from "../../utils/axios";

//---------------------------------------------------------------

// GET =>  get All Ministerial Decisions
export const getAllMinisterialDecisions = createAsyncThunk(
  "ministerial_decisions/getAllMinisterialDecisions",
  async (_, thunkAPI) => {
    try {
      const response = await axios.get(URLS.ministerialDecisionsURL);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

// POST =>  Add  Ministerial Decision
export const addMinisterialDecisions = createAsyncThunk(
  "ministerial_decisions/addMinisterialDecisions",
  async (data, thunkAPI) => {
    try {
      const response = await axios.post(URLS.ministerialDecisionsURL, data, {
        headers: {
          Accept: "*/*",
          "Content-Type": "multipart/form-data",
        },
      });
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

// DELTE =>  delete Ministerial Decisions
export const deleteMinisterialDecisions = createAsyncThunk(
  "ministerial_decisions/deleteMinisterialDecisions",
  async (id, thunkAPI) => {
    try {
      const response = await axios.delete(
        `${URLS.ministerialDecisionsURL}/${id}`
      );
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  }
);
